
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/survey/update-pharmacies",
      function () {
        return require("private-next-pages/account/survey/update-pharmacies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/survey/update-pharmacies"])
      });
    }
  